<template>
  <div class="my_close_btn delContent lineControl" @click="del_module" :title='title'><span class="el-icon-close" ></span></div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_close_btn',
  data() {
    return {
    };
  },
  props:{
    module: {
      type:Object,
      default:null
    },
    column: {
      type: Object,
      default: null
    },
    moduleIndex: {
      type: Number,
      default: 0
    },
    coverClick: { // 覆盖默认点击事件
      type: Boolean,
      default: false
    },
    title:{
      type:String,
      default:i18n.t('widgets_basic_article_list_index_414')
    }
  },
  methods: {
    del_module() {
      if (!this.coverClick) this.templet.del_module(this.column.widgets_id, this.moduleIndex, this.module.data.anchor_id)
      if (this.coverClick) this.$emit('click')
      this.templet.dialog_close();
      if(this.module.name == 'basic_zhlanguage') {
        this.$store.state.myRender.common.setting.zhLanguageOpen = false
        this.$store.state.myRender.common.setting.zhLanguageAdress = ''
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my_close_btn:hover {
  background-color: #2e343B
}
</style>



// WEBPACK FOOTER //
// src/components/my_close_btn/index.vue